var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m405.5 239.5v245.6h-330.4v-245.6l165.2-149.3z",
    fill: "#e6bc53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m387.2 485.1h-312.1v-245.6l165.2-149.3 146.9 132.8z",
    fill: "#ffd15c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.5 239.5v20.7l-165.2-149.2-165.2 149.2v-20.7l165.2-149.3z",
    fill: "#e6bc53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.3 90.2-208.4 188.2-31.1-35.1 239.5-216.4 239.5 216.4-31.2 35.1z",
    fill: "#f3705a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.1 315.5h104.3v169.6h-104.3z",
    fill: "#354956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m188.1 315.5h88.2v169.6h-88.2z",
    fill: "#415a6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.5 93.1c83.1 0 125.4 76 96.9 151.3-22.6 59.8-74.2 133.1-96.9 172.3-23.9-41.4-79.6-119.9-100.1-181.4-24-72.1 23.5-142.2 100.1-142.2z",
    fill: "#e64343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.8 402.2c-26.7-43.5-73.1-112-91.4-166.9-23.1-69.4 20-136.9 91.6-141.9 77.3 5.2 115.5 78.4 88.1 151-20.1 53-63 116.7-88.3 157.8z",
    fill: "#ff4a4a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m405.2 244.9c26.7 0 48.5-21.8 48.5-48.5s-21.8-48.5-48.5-48.5-48.5 21.8-48.5 48.5c0 26.8 21.8 48.5 48.5 48.5z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.e29f37309273cd605dc0a822b9988e97.svg";
export { ForwardRef as ReactComponent };